exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2OK-fv8DsiaxpgdYhOorur{display:none}@media only screen and (min-width:768px){._2OK-fv8DsiaxpgdYhOorur{display:table-cell}}._1d5TOX2tjT9gO7CBUntvLH{padding-right:1.42857rem}@media only screen and (min-width:768px){._1d5TOX2tjT9gO7CBUntvLH{padding-right:0}}._255pJtwFohXsf9Calr91vn{border-top:.07143rem solid #f3f5f7}._2vkpdETQ5SGEVjb5DcR08F{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:.28571rem}._36B57GYvCOeAWuy8Ys0VvS{height:1.28571rem;width:1.28571rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PerformanceCard_presentColomn": "_2OK-fv8DsiaxpgdYhOorur",
	"PerformanceCard_mobileLastColomn": "_1d5TOX2tjT9gO7CBUntvLH",
	"PerformanceCard_expansion": "_255pJtwFohXsf9Calr91vn",
	"PerformanceCard_parentPageLink": "_2vkpdETQ5SGEVjb5DcR08F",
	"PerformanceCard_parentPageArrow": "_36B57GYvCOeAWuy8Ys0VvS"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Dashboard/PerformanceCard/AveragesOverviewTable/style.postcss
// module id = 1286
// module chunks = 0